import React, { Suspense } from 'react';
import 'core-js/stable/object';
import { createRoot } from 'react-dom/client';
import { MemoryRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Loader from '../components/Loader';
import '../i18n';
import { getTheme } from '../utils/theme';
import DependenciesList from './DependenciesList';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Suspense fallback={<Loader />}>
    <MemoryRouter>
      <ThemeProvider theme={createTheme(getTheme())}>
        <CssBaseline />
        <DependenciesList />
      </ThemeProvider>
    </MemoryRouter>
  </Suspense>,
);
